import React from 'react';
import documents from '../../assets/document/documents.png';
import { useTranslation } from 'react-i18next';
import "./noProduct.css";


function NoProduct() {
  const { t } = useTranslation();
  return (
      <div className="up">
        
        <div className="up-container">
         <div>
         <p className="up-text1">{t('products.noProductsAvailable')}</p>
         
                <img src={documents} alt=""/>
            </div>
        </div>
    </div>
    
  );
}
export default NoProduct;